import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
      <Row>
        <Col md={8} className="home-about-description">
          <h1 className="home-about-heading" style={{ fontSize: "2.6em" }}>
            LET ME <span className="purple"> INTRODUCE </span> MYSELF
          </h1>
          <p className="home-about-body">
            Hey there! I’m a passionate full-stack developer with 3.5 years of experience, obsessed with building innovative web solutions. 🌟
            <br />
            <br />I’m fluent in
            <i>
              <b className="purple"> JavaScript, and the Full stack, </b>
            </i>
            crafting seamless, scalable applications that make an impact.
            <br />
            <br />
            My sweet spot? Developing &nbsp;
            <i>
              <b className="purple">cutting-edge web technologies and products </b>
            </i>
            that users love, with a focus on performance and design.
            <br />
            <br />
            I thrive on creating dynamic solutions with <b className="purple">Node.js, React.js, Next.js, Strapi,</b> and
            <i>
              <b className="purple"> frameworks like laravel, CodeIgniter </b> 
            </i>
            while styling with <b className="purple">Tailwind CSS and Bootstrap </b> for pixel-perfect interfaces.
            <br />
            <br />
            From WordPress to custom web apps and headless CMS with <b className="purple">Strapi, </b> I bring ideas to life with clean code and modern frameworks.
          </p>
        </Col>
        <Col md={4} className="myAvtar">
          <Tilt>
            <img src={myImg} className="img-fluid" alt="avatar" />
          </Tilt>
        </Col>
      </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ghulam-mustafa45"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://twitter.com/Soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li> */}
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ghulam-mustafa-9a895921b/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://www.instagram.com/soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li> */}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
